var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"text-align":"center"}},[_vm._v("\n      agent apply\n    ")])])])
}]

export { render, staticRenderFns }